"use client";

// Career Launch가 무슨 서비스인지 한눈에 — 로그인·초대코드 등 진입 화면 어디서든 공용.
// 로그인/등록 여부와 무관하게 방문자가 "4주 취업 준비 프로그램"임을 바로 인지하게 한다.
import { ClipboardText, FileText, ChatCircleText, Microphone } from "@phosphor-icons/react";
import { useLaunchT } from "../../lib/launch/i18n";

export function CareerLaunchIntro({ className = "" }: { className?: string }) {
  const t = useLaunchT();
  const steps = [
    {
      icon: ClipboardText,
      label: t("취업 진단·직무 찾기", "Career check · find roles", "求职诊断·找方向", "Chẩn đoán·tìm nghề", "就職診断・職種探し", "Cek karier·cari peran")
    },
    {
      icon: FileText,
      label: t("이력서 완성", "Build your resume", "完成简历", "Hoàn thiện CV", "履歴書を完成", "Susun resume")
    },
    {
      icon: ChatCircleText,
      label: t("자기소개서 완성", "Write your cover letter", "完成自我介绍", "Viết thư giới thiệu", "自己紹介書を完成", "Tulis surat lamaran")
    },
    {
      icon: Microphone,
      label: t("AI 모의 면접", "AI mock interview", "AI 模拟面试", "Phỏng vấn thử AI", "AI模擬面接", "Wawancara simulasi AI")
    }
  ];

  return (
    <div className={`overflow-hidden rounded-3xl bg-[color:var(--v2-band)] ${className}`}>
      <img
        src="/img_global_career_launch.webp"
        alt={t("Career Launch", "Career Launch", "Career Launch", "Career Launch", "Career Launch", "Career Launch")}
        className="block h-auto w-full"
        loading="lazy"
      />
      <div className="p-5 md:p-6">
      <span className="inline-flex items-center rounded-full bg-[color:var(--v2-accent-weak)] px-2.5 py-1 text-[12px] font-bold text-[color:var(--v2-accent)]">
        {t("4단계 프로그램", "4-step program", "4个步骤的项目", "Chương trình 4 bước", "4ステッププログラム", "Program 4 langkah")}
      </span>
      <p className="mt-3 break-keep text-[15px] leading-[1.6] text-[color:var(--v2-ink-3)]">
        {t(
          "AI 코치와 함께 취업 진단부터 이력서·자기소개서·모의면접까지 4단계에 걸쳐 끝내고, 완성한 서류로 APLY 채용에 바로 연결돼요.",
          "With an AI coach, finish everything from a career check to your resume, cover letter, and mock interview across 4 steps — then connect straight to APLY hiring with your completed docs.",
          "在 AI 教练的陪伴下，通过 4 个步骤完成从求职诊断到简历、自我介绍、模拟面试的全部内容，并凭完成的材料直接对接 APLY 招聘。",
          "Cùng huấn luyện viên AI, hoàn thành mọi thứ từ chẩn đoán nghề đến CV, thư giới thiệu và phỏng vấn thử qua 4 bước — rồi kết nối thẳng đến tuyển dụng APLY bằng hồ sơ đã hoàn thiện.",
          "AIコーチと一緒に、就職診断から履歴書・自己紹介書・模擬面接まで4ステップで仕上げ、完成した書類でそのままAPLY採用につながります。",
          "Bersama pelatih AI, selesaikan semuanya dari cek karier hingga resume, surat lamaran, dan wawancara simulasi dalam 4 langkah — lalu terhubung langsung ke rekrutmen APLY dengan dokumen jadi."
        )}
      </p>
      <div className="mt-4 grid grid-cols-2 gap-2">
        {steps.map((s, i) => (
          <div key={i} className="flex min-w-0 items-center gap-2 rounded-2xl bg-white px-2.5 py-3 min-[360px]:px-3">
            <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-lg bg-[color:var(--v2-accent-weak)] text-[color:var(--v2-accent)]">
              <s.icon className="h-4 w-4" weight="fill" />
            </span>
            <span className="min-w-0 text-[13px] font-semibold leading-tight text-[color:var(--v2-ink-2)]">{s.label}</span>
          </div>
        ))}
      </div>
      </div>
    </div>
  );
}
